var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 402,
    viewBox: "0 0 704 402",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 379.35C0 379.35 5.4 383.4 6.95 390C8.5 396.6 14.25 401 14.25 401",
    stroke: "url(#paint0_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 361.35C0 361.35 18.5 367.05 23.4 381.4C28.1 395.35 47.1 401 47.1 401",
    stroke: "url(#paint1_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 343.35C0 343.35 31.6 350.7 39.8 372.75C47.7 394 79.95 401 79.95 401",
    stroke: "url(#paint2_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 325.3C0 325.3 44.65 334.35 56.25 364.1C67.3 392.7 112.75 401 112.75 401",
    stroke: "url(#paint3_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 307.3C0 307.3 57.75 318 72.65 355.45C86.9 391.35 145.6 401 145.6 401",
    stroke: "url(#paint4_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 289.3C0 289.3 70.85 301.65 89.1 346.85C106.5 390 178.45 401 178.45 401",
    stroke: "url(#paint5_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 271.25C0 271.25 83.9 285.3 105.5 338.15C126.1 388.7 211.3 401 211.3 401",
    stroke: "url(#paint6_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 253.25C0 253.25 97 268.95 121.95 329.55C145.7 387.35 244.15 401 244.15 401",
    stroke: "url(#paint7_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 235.25C0 235.25 110.1 252.6 138.4 320.9C165.3 386 276.95 401 276.95 401",
    stroke: "url(#paint8_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 217.2C0 217.2 123.15 236.2 154.8 312.25C184.95 384.7 309.8 401 309.8 401",
    stroke: "url(#paint9_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 199.2C0 199.2 136.25 219.9 171.25 303.6C204.55 383.35 342.65 401 342.65 401",
    stroke: "url(#paint10_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 181.2C0 181.2 149.35 203.55 187.65 295C224.15 382 375.5 401 375.5 401",
    stroke: "url(#paint11_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 163.15C0 163.15 162.4 187.15 204.1 286.3C243.75 380.7 408.3 401 408.3 401",
    stroke: "url(#paint12_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 145.15C0 145.15 175.5 170.8 220.5 277.65C263.35 379.35 441.15 401 441.15 401",
    stroke: "url(#paint13_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 127.1C0 127.1 188.6 154.45 236.95 269C282.95 378 474 401 474 401",
    stroke: "url(#paint14_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 109.1C0 109.1 201.65 138.1 253.35 260.35C302.55 376.7 506.85 401 506.85 401",
    stroke: "url(#paint15_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 91.1C0 91.1 214.75 121.75 269.8 251.75C322.15 375.35 539.7 401 539.7 401",
    stroke: "url(#paint16_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 73.05C0 73.05 227.85 105.4 286.25 243.05C341.75 374 572.5 401 572.5 401",
    stroke: "url(#paint17_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 55.05C0 55.05 240.9 89.05 302.65 234.45C361.35 372.7 605.35 401 605.35 401",
    stroke: "url(#paint18_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 37.0499C0 37.0499 254 72.7 319.1 225.8C380.95 371.35 638.2 401 638.2 401",
    stroke: "url(#paint19_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19C0 19 267.1 56.3 335.5 217.15C400.55 370 671.05 401 671.05 401",
    stroke: "url(#paint20_linear_2073_1269)",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1C0 1 280.15 40 351.95 208.5C420.15 368.7 703.85 401 703.85 401",
    stroke: "url(#paint21_linear_2073_1269)",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2073_1269",
    x1: 7.125,
    y1: 401,
    x2: 7.125,
    y2: 379.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2073_1269",
    x1: 23.55,
    y1: 401,
    x2: 23.55,
    y2: 361.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2073_1269",
    x1: 39.975,
    y1: 401,
    x2: 39.975,
    y2: 343.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2073_1269",
    x1: 56.375,
    y1: 401,
    x2: 56.375,
    y2: 325.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2073_1269",
    x1: 72.8,
    y1: 401,
    x2: 72.8,
    y2: 307.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2073_1269",
    x1: 89.225,
    y1: 401,
    x2: 89.225,
    y2: 289.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2073_1269",
    x1: 105.65,
    y1: 401,
    x2: 105.65,
    y2: 271.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2073_1269",
    x1: 122.075,
    y1: 401,
    x2: 122.075,
    y2: 253.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2073_1269",
    x1: 138.475,
    y1: 401,
    x2: 138.475,
    y2: 235.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2073_1269",
    x1: 154.9,
    y1: 401,
    x2: 154.9,
    y2: 217.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2073_1269",
    x1: 171.325,
    y1: 401,
    x2: 171.325,
    y2: 199.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2073_1269",
    x1: 187.75,
    y1: 401,
    x2: 187.75,
    y2: 181.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2073_1269",
    x1: 204.15,
    y1: 401,
    x2: 204.15,
    y2: 163.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2073_1269",
    x1: 220.575,
    y1: 401,
    x2: 220.575,
    y2: 145.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2073_1269",
    x1: 237,
    y1: 401,
    x2: 237,
    y2: 127.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2073_1269",
    x1: 253.425,
    y1: 401,
    x2: 253.425,
    y2: 109.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2073_1269",
    x1: 269.85,
    y1: 401,
    x2: 269.85,
    y2: 91.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2073_1269",
    x1: 286.25,
    y1: 401,
    x2: 286.25,
    y2: 73.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2073_1269",
    x1: 302.675,
    y1: 401,
    x2: 302.675,
    y2: 55.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2073_1269",
    x1: 319.1,
    y1: 401,
    x2: 319.1,
    y2: 37.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2073_1269",
    x1: 335.525,
    y1: 401,
    x2: 335.525,
    y2: 19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2073_1269",
    x1: 351.925,
    y1: 401,
    x2: 351.925,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#696969",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#696969"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8);
export default __webpack_public_path__ + "static/media/Group (8).0591910d45345104381f5355a0f6abed.svg";
export { ForwardRef as ReactComponent };